module.exports = __webpack_public_path__ + "img/logo.24e16dfc.png";